import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'
import { TestRoutineOverlay } from '#app/routes/mocra+/_form+/components/test-routines/overlay.tsx'
import {
	createTestRoutineDraft,
	type TestRoutineDraft,
} from '#app/routes/mocra+/_form+/components/test-routines/types.ts'

type Props = {
	readonly onSubmit: (draft: TestRoutineDraft) => void
	readonly defaultValue?: TestRoutineDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function TestRoutineAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: TestRoutineDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add routine'}
			</AddButton>
			<TestRoutineOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createTestRoutineDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
